define([
	"dgrid/_StoreMixin",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-style",
	"dojo/on",
	"dojo/when",
	"dijit/form/Button",
	"csi",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale"
], function(_StoreMixin,declare,lang,domStyle,on,when,Button,csi,_,html,locale) {

	return declare(_StoreMixin, {
		// summary:
		//		An extension for adding ability to display more results for a List or Grid.
		//		This currently only works with read-only stores.
		//      To change the functionality to Infinite Scroll add attribute  infiniteScroll:true; on grid, this will replace More button with infinite scroll

		// FIX - document
		bufferSpace: 10,

		/** @property {VoidFunction} onTotal - pass total to callback */
		onTotal: null,

        scrollDelay: 10,
        showTotal: false,

		// infiniteScroll: Boolean
		//		Indicate if more results should be rendered when scroll bar hits bottom of grid
		infiniteScroll: false,

		// moreLabel: String
		//		Label of more button
		moreLabel: "More...",

		// moreRows: Number
		//		Number of rows (items) to add to display each time More is clicked (and initially).
		moreRows: 20,

		// private
		_moreNode: null,
		_moreButton: null,
		_moreStart: 0,
		_moreData: false,
		
		getMoreRows: function (start) {
			// summary: this is to enable ability to over ride moreRow calculation logic on grid
			return this.moreRows;
		},

        postCreate: function () {
        	// summary: this is applicable only for infinite scroll
            var self = this;

            function scrollCallback(event) {
                var scrollNode = self.bodyNode,
                visibleTop = (event && event.scrollTop) || scrollNode.scrollTop,
                containerHeight = scrollNode.scrollHeight-scrollNode.offsetHeight;
                if ((visibleTop + self.bufferSpace) >= containerHeight && self._moreData) {
                	self.showMore();
                }
            }

            this.inherited(arguments);

            if (self.infiniteScroll) {
            	on(this.bodyNode, "scroll", _.debounce(scrollCallback, self.scrollDelay, true));
            }
        },

		newRow: function(){
			// summary: increment _moreStart when new row is added
			if (this._moreStart) {
				++this._moreStart;
			}

			return this.inherited(arguments);
		},

		noMoreData: function() {
			if (this.noDataMessage) {
				this.noDataNode && (this.noDataNode.innerHTML = '');
				this.noDataNode = html.create("div", {
					"class": "dgrid-no-data",
					innerText: this.noDataMessage
				}, this.contentNode);
			}
		},

		refresh: function(){
			this.inherited(arguments);

			if (this.store) {
				delete this._moreLoading;
				this._moreNode = null;
				this._moreButton = null;
				this._moreStart = 0;
				this.showMore();
			} else {
				this.noMoreData();
			}
		},

		removeRow: function(rowElement, justCleanup){
			// summary: decrement _moreStart when row is removed
			if (this._moreStart) {
				--this._moreStart;
			}

			return this.inherited(arguments);
		},

		showMore: function() {
			// summary:
			//		Loads more results.
			if (this._moreLoading) return;

			var grid = this;
			var moreRows = this.getMoreRows(grid._moreStart);

			this._trackError(function(){
				var	mn = grid._moreNode;
				var	btn = grid._moreButton;

				if (!mn) {
					mn = grid._moreNode = html.create("div", {
						"class": "csi-dgrid-more"
					}, grid.contentNode);

					btn = grid._moreButton = new Button({
						"class": html.CSS_BUTTON_SECONDARY + " csi-more-btn",
						onClick: lang.hitch(grid, grid.showMore)
					});
					btn.placeAt(mn);
					btn.startup();
				}

				if (grid.loadingMessage) {
					btn.set("label", _.escape(grid.loadingMessage));
				}

				btn.set("disabled", true);
				grid._moreLoading = true;

				// Run new query and pass it into renderArray
				var options = lang.mixin(grid.get("queryOptions"), {
					start: grid._moreStart,
					count: moreRows
				});

				var	results = grid.store.query(grid.query, options);

				return when(grid.renderArray(results, mn, options), function() {
					delete grid._moreLoading;

					grid._moreStart += moreRows;

					when(results.total, function(total) {
						var	message;

						grid.onTotal?.(total);

						if (!total) {
							// If there are no results, display the no data message.
							grid.noMoreData();
							grid._moreData = false;
							message = "SEARCH_NO_RESULTS";
						} else if (grid._moreStart >= total) {
							html.destroyElement(mn);
							grid._moreNode = grid._moreButton = null;
							grid._moreData = false;
							message = "SEARCH_RESULTS_FINISHED";
						} else {
							if (!grid.infiniteScroll) {
								btn.set("disabled", false);
								btn.set("label", _.escape(grid.moreLabel));
								html.clear(grid.noDataNode);
							} else {
								html.destroyElement(mn);
								grid._moreNode = grid._moreButton = null;
								message = "SEARCH_MORE";
							}

							grid._moreData = true;
						}

						// render footer
						if (message && grid.showFooter) {
							html.clear(grid.footerNode);
							html.create("span", {
								"class": "csi-dgrid-message",
								innerText: locale.resource(message)
							}, grid.footerNode);

							if (total && grid.showTotal) {
								html.create("span", {
									"class": "csi-dgrid-total",
									innerText: locale.getResultCountString("SEARCH_TOTAL_RESULTS", {resultCount: total}, total > 1)
								}, grid.footerNode);
							}
						}

						// display more button if there are still more results to show
						html.setVisible(mn, grid._moreData);
					});
				}, function(error){
					// restore label and hide more button, then display error
					delete grid._moreLoading;
					btn.set("label", _.escape(grid.moreLabel));
					html.setVisible(mn, false);
					grid.set("noDataMessage", error.message);
					grid.noMoreData();
					throw error;
				});
			});
		}
	});
});
